export function convertUnicodeChars(str) {
  if (!str) return;
  return str.replace(/\\u[\dA-Fa-f]{4}/g, (match) =>
    String.fromCharCode(parseInt(match.replace('\\u', ''), 16))
  );
}
